import React, { useEffect, useState } from 'react';
import { Container, Header, Segment, Button, Modal, Pagination } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'
import cogoToast from 'cogo-toast';

import TitleBar from '../titleBar/titleBar';
import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import EditModal from '../modals/editModal';
// import BillApprovalModal from './billApprovalModal';

import BillActionButton from './billActionButton';
// import PaymentActionButton from './paymentActionButton';
// import IntegratedReferenceNumber from './integratedReferenceNumber';
import { DATE_FORMATS, EnableIntegratedReferenceNo, EnableIntegratedRefErrorContent, transworldCustomer } from "../../config/const";

//Redux Actions
import { deleteBill, getBills, getFilteredBills, getPenalties, undoApproveBill } from '../../redux/actions/billActions';
import { getVendorPurchaseOrder } from '../../redux/actions/purchaseOrderActions';
import { approveBills, rejectBills } from '../../redux/actions/approvalActions';
import { getDebitNote } from './debitNoteCRUD';
import IntegratedReferenceNumber from '../bill/integratedReferenceNumber';


function DebitNoteTable(props) {

const { billsData, billsLoading, getBills, deleteBill,
deleteBillIsLoading, getVendorPurchaseOrder, approveBills, rejectBills,
getFilteredBills, getPenalties, undoApproveBill,
penaltiesData, penaltiesLoading } = props;

const [debitNoteData, setdebitNoteData] = useState()
const [debitNoteCurrentPageData, setDebitNoteCurrentPageData] = useState(1)
const [debitNotePagination,setDebitNotePagination] = useState({})

useEffect(()=>{

const filteredData = {
api_token: localStorage.getItem('apiToken'),
customerNo: localStorage.getItem('customerNo'),
userId: localStorage.getItem('userId'),
searchString: props.searchValue ? props.searchValue : ''
}

getFilteredBills(filteredData)

},[props.searchValue])

useEffect(() => {
let temp = getDebitNote(debitNoteCurrentPageData)
temp.then((resp) => {
setdebitNoteData(resp.data && resp.data.length ? resp.data : resp.data.data)
setDebitNotePagination(resp.pagination)
}).catch((err) => {
})
},[])

const [selectedRows, setSelectedRows] = useState([]);
const [activeSelect, setActiveSelect] = useState(false);
const [grid, setGrid] = useState({});
const [openApprovalModal, setOpenApprovalModal] = useState(false);
const [approveButton, setApproveButton] = useState(false);


const getSelectedRows = (grid) => {

const selected = grid.api.getSelectedRows()
setGrid(grid)

setSelectedRows(selected);
if (selected.length > 0) {
setActiveSelect(true)
} else {
setActiveSelect(false)
}
};


const handleCloseBillApproval = () => {
setOpenApprovalModal(false)
};

const handleOpenApprovalModal = () => {
setOpenApprovalModal(true)
};

const approveBillsSelected = (billDetails) => {
setApproveButton(true)

const approvalData = {
customerNo: localStorage.getItem('customerNo'),
userId: localStorage.getItem('userId'),
billDetails: billDetails
}

approveBills(approvalData);
setApproveButton(false)
}

const approveBillsDirectly = () => {

let billDetails = []
selectedRows && selectedRows.map((o, i) => {
let temp = {}
temp.billReferenceNo = o.refNo
temp.billNo = o.billNo
temp.billDate = o.billDate
temp.billAmount = o.billAmount
temp.billReceiptDate = o.billReceiptDate
temp.approvalStatus = "Approved"
temp.vendorCode = o.vendorCode
temp.vendorName = o.vendorName
temp.penaltyList = []
billDetails[i] = temp
});

const approvalData = {
customerNo: localStorage.getItem('customerNo'),
userId: localStorage.getItem('userId'),
billDetails: billDetails
}

approveBills(approvalData)

}

const rejectBillsSelected = () => {

let billDetails = [];
selectedRows && selectedRows.map((o, i) => {
let temp = {};
temp.billReferenceNo = o.refNo
temp.vendorCode = o.vendorCode
temp.approvalStatus = "Rejected"

billDetails[i] = temp
})

const rejectData = {
customerNo: localStorage.getItem('customerNo'),
userId: localStorage.getItem('userId'),
billDetails: billDetails
}

rejectBills(rejectData)
}


const getFilterDates = (val,startDate, endDate, billStatus,vendorCode, vehicleNo,VehicleId, branchId) => {

const filteredData = {
api_token: localStorage.getItem('apiToken'),
customerNo: localStorage.getItem('customerNo'),
userId: localStorage.getItem('userId'),
fromDate: startDate != null ? moment(startDate).format(DATE_FORMATS.DD_MM_YYYY) : null,
toDate: endDate != null ? moment(endDate).format(DATE_FORMATS.DD_MM_YYYY) : null,
billStatus:billStatus ? billStatus : [],
vendorCode:vendorCode ? vendorCode : '',
vehicleNo:vehicleNo,
branchId:branchId
}

getFilteredBills(filteredData)
}

const refreshDates = () => {
window.location.reload();
}
let columnDefs = [
{
headerName:  'Debit Note No.', field: 'debitNoteNo', cellRenderer: 'paymentModalRenderer',
tooltipField: EnableIntegratedRefErrorContent ? 'integratedReferenceNumberErrorContent' : 'vendorBillNo',
enableRowGroup: true, enablePivot: true, filter: true
        },
        { headerName: 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Bill Reference No.', field: 'billRefNo', tooltipField: 'billRefNo', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: transworldCustomer ? 'Integrated Reference Number' :'SAP Reference No.', field: 'integratedReferenceNumber', cellRenderer: 'integratedReferenceNo', enableRowGroup: true, enablePivot: true, filter: true, hide: !EnableIntegratedReferenceNo, },
        { headerName: 'Approved On', field: 'approvedThirdpartyApiDate', tooltipField: 'approvedThirdpartyApiDate', enableRowGroup: true, enablePivot: true, filter: true, hide : !transworldCustomer },
        { headerName: 'Transaction Date', field: 'transactionDate', tooltipField: 'billReceiptDate', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Debit Amount (Rs)', field: 'debitAmount', tooltipField: 'debitAmount', enableRowGroup: true, enablePivot: true, filter: true },
        // { headerName: 'Remarks', field: 'remarks', tooltipField: 'remarks', width: 160, suppressToolPanel: true },
        { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
        // { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
        // { headerName: 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
        // { headerName: 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
        { headerName: 'Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, pinned: "right" }
    ]

let columnKeys = ['vendorBillNo', 'vendorBillDate', 'refNo', 'billReceiptDate', 'vendorName', 'billAmount', 'pendingAmount', 'expectedPaymentDate', 'penalties', 'status', 'createdOn', 'createdBy', 'modifiedOn', 'modifiedBy']

let frameworkComponents = {
actionRenderer: BillActionButton,
integratedReferenceNo: IntegratedReferenceNumber,
}

let rowData = []

debitNoteData && debitNoteData.forEach((object, index) => {
let temp = {}
temp.debitNoteNo = object.debitNoteNo
temp.vendorBillDate = moment(object.billDate).format(DATE_FORMATS.DD_MM_YYYY || 'DD-MM-YYYY')
temp.refNo = object.referenceNo
temp.billRefNo = object.billReferenceNo

temp.integratedReferenceNumber = object.integratedReferenceNumber
temp.integratedReferenceNumberErrorContent = object.integratedReferenceNumberErrorContent
temp.reloadIntegratedRefNo = true
temp.approvedThirdpartyApiDate = object.approvedThirdpartyApiDate

temp.vendorId = object.vendorId
temp.branchCode = object.branchCode
temp.branchName = object.branchName
temp.transactionDate = object.transactionDate
temp.vendorName = object.vendorName
temp.vendorGroup = ''
temp.debitAmount = object.debitAmount
temp.pendingAmount = object.pendingAmount
temp.expectedPaymentDate = moment(object.expectedPaymentDate).format(DATE_FORMATS.DD_MM_YYYY || 'DD-MM-YYYY')
temp.status = object.approvalStatus
temp.createdOn = object.createdOn
temp.createdBy = object.createdByName
temp.modifiedOn = object.updatedOn
temp.file = object.filePath
temp.remarks = object.remarks
temp.coverLetter = object.billCoverLetter
temp.modifiedBy = object.updatedByName
temp.totalPenaltyAmt = object.totalPenaltyAmt
temp.deleteBill = deleteBill
temp.isLoading = deleteBillIsLoading
temp.getVendorPurchaseOrder = getVendorPurchaseOrder
temp.getPenalties = getPenalties
temp.penaltiesData = penaltiesData
temp.penaltiesLoading = penaltiesLoading
temp.debitNoteId = object.debitNoteId
//Extra Data for Edit
temp.vendorCode = object.vendorCode
temp.billNo = object.billNo
temp.billDate = object.billDate
temp.billPO = object.bill_po_mapping
temp.billId = object.billId
temp.GLCode = object.GLCode
temp.branchName = object.branchName
rowData[index] = temp
})

const handlePaginationChange = (e, { activePage }) => {
getDebitNote(activePage).then((resp) => {
setdebitNoteData(resp.data.data)
setDebitNotePagination(resp.pagination)
}).catch((err) => {
})
setDebitNoteCurrentPageData(activePage)

}

return (
<React.Fragment>
<div style={{ position: 'relative' }}>

<AgGridTable
columnDefs={columnDefs}
rowData={rowData}
pagination={false}
searchValue={props.searchValue}
link="/add-bill"
baseURL={props}
hiddenNewPopupBtn={true}
hiddenImportPopupBtn={true}
columnKeys={columnKeys}
extraComponents={frameworkComponents}
titleBarTitle="Debit Note"
handleSearch={props.handleSearch}
rowSelected={getSelectedRows}
isRowSelectable={function (rowNode) {
return (localStorage.getItem('customerNo') == '1166' || localStorage.getItem('customerNo') == '1165') ? true : rowNode.data && rowNode.data.status !== "Pending" ? false : true;
}}
dateFilter={true}
getFilterDates={getFilterDates}
refreshDates={refreshDates}
suppressRowSelection={true}
debitNote={true}
billsData={billsData}
dataLoading={billsLoading}
disableFilter={true}
hiddenNew={true}
/>
<Pagination
key={debitNotePagination?.currentPage}
defaultActivePage={
debitNotePagination?.currentPage
}
firstItem={null}
lastItem={null}
onPageChange={handlePaginationChange}
pointing
secondary
totalPages={
debitNotePagination?.totalPages
? debitNotePagination?.totalPages
: 0
}
/>

</div>
</React.Fragment>
)
}

const mapStatetoProps = (state) => ({
billsData: state.getBillsData.bills.data,
billsLoading: state.getBillsData.isLoading,
deleteBillIsLoading: state.deleteBillData.isLoading,
penaltiesData: state.getPenaltiesData.billPenalties.data,
penaltiesLoading: state.getPenaltiesData.isLoading
})

export default connect(mapStatetoProps, { getBills, deleteBill, getVendorPurchaseOrder, approveBills, rejectBills, getFilteredBills, getPenalties, undoApproveBill })(DebitNoteTable)
